import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[gstarComponentHost]',
})
export class ComponentHostDirective {
  readonly viewContainerRef = inject(ViewContainerRef);
}
